<template>
  <div class="right-nav">
    <ul>
      <li class="right-nav-item" @click="goHome">
        <div class="right-nav-item-content">
          <i class="iconfont icon-shouye"></i>
          <span>首页</span>
        </div>
      </li>
      <li class="right-nav-item">
        <div class="right-nav-item-content">
          <i class="iconfont icon-wode">
          </i>
          <span>用户管理</span>
        </div>
      </li>
      <li class="right-nav-item">
        <div class="right-nav-item-content">
          <i class="iconfont icon-tongzhi"></i>
          <span>最新动态</span>
        </div>
      </li>
      <li class="right-nav-item">
        <div class="right-nav-item-content" @click="top()">
          <i class="iconfont icon-fanhuidingbu"></i>
          <span>返回顶部</span>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    goHome() {
      window.open('/#/home', '_blank');
    },
    top() {
      let currentScroll =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(this.top);
        window.scrollTo(0, currentScroll - currentScroll / 5);
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminCenter/area/rightNav.vue